import React, { useContext, useEffect, useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import ProductCheckCard from './card';
import { TrackAddModal } from './Modal';
import { GET } from '../../../utils/requests';
import { getuseruri, product_uri } from '../../../uri';
import { AuthContext } from '../../../context/auth';
import { TYPES } from '../../../utils/type';
import Paginations from '../../../components/Pagination';
import { Skeleton, useToast } from '@chakra-ui/react';
import { Empty } from 'antd';
import { Delivery } from './Modal/delivery';
import { IoCard } from "react-icons/io5";
import axios from "axios";

const ProductCheck = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const [path, setPath] = useState(1);
  const {currentUser} = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({limit:40, all:'', totalPage:'',username:'', status:''});
  const [load, setLoad] = useState(false);
  const [status, setStatus] = useState(false);
  const nav = useNavigate();
  const [qpay, setQpay] = useState({});
  const [totalPayment, setTotalPayment] = useState(0);
  const [paymentData, setPaymentData] = useState([]);
  const toast = useToast();
  const [paymentStatus, setPaymentStatus] = useState(null);

  const callback = () =>{
    Get();
  }

  const Get = async () => {
    setLoad(true);
    let st ;
    if(path === 1){
      st = TYPES.ALL
    }else if(path === 2){
      st = TYPES.REQUESTED
    }else if(path === 3){
      st = TYPES.EREEN
    }else if(path === 4){
      st = TYPES.IRSEN
    }else if(path === 5){
      st = TYPES.CONFIRM
    }
    try{
      const res = await GET(getuseruri+`/tracks?token=${currentUser}&page=${page}&status=${st}&limit=${pagination.limit}`);
      setData(res.data.data);
      setPagination({...pagination, all:res.data.all, totalPage:res.data.totalPage});
      const sum = res.data.data.reduce((acc, item) => {
        if (item.payIsCheck === null) {
          const payment = item.payment ? parseFloat(item.payment) : 0;
          return acc + payment;
        }
        return acc;
      }, 0);

      setTotalPayment(sum);

      setLoad(false);
    }catch(err){
      if(err.response.status === 444){
        nav("/login");
      }
    }
  }

  useEffect(() => {
    if(!currentUser){
      nav("/login");
      return
    }
    Get();
  }, [page, path])

  const changePage = (page) => {
    setPage(page)
  };

  const initiatePayment = async () => {
    try {
      setLoad(true);
      const res = await axios.post(product_uri + `/initiate-payment/cargo`, {
        user_id: currentUser,
        payment: totalPayment,
      });
      
      if (res.data) {
        setQpay(res.data.data);
        setPaymentData(res.data.data.urls);
        setStatus(true);
      } else {
        throw new Error("Төлбөрийн холбоос байхгүй байна");
      }
      
      setLoad(false);
    } catch (err) {
      console.log(err);
      setLoad(false);
      toast({
        title: "Төлбөр эхлүүлэхэд алдаа гарлаа",
        description: err.response?.data?.message || "Дахин оролдоно уу",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };


    const verifyPayment = async () => {
      console.log("A")
      try {
        setLoad(true);
        const res = await axios.post(product_uri + `/verify-payment/cargo`, {
          user_id: currentUser
        });
        if (res.status == 200) {
          Get();
          setStatus(false);
          toast({
            title: "Төлбөр амжилттай төлөгдлөө",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        } 
        setLoad(false);
        toast({
          title: "Төлбөр төлөгдөөгүй байна",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
        
      } catch (err) {
        setLoad(false);
        toast({
          title: "Төлбөр баталгаажуулахад алдаа гарлаа",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    };

  const handleLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  
  if(currentUser){
    return (
      <div className='font-Roboto text-black mt-8 w-full mb-10'>
          <div>
              <h1 className='font-bold text-md uppercase text-xl'>Миний карго</h1>
              <p>My cargo</p>
          </div>
  
          <div className='flex justify-between uppercase xs:text-xs md:text-md bg-custom-gradient rounded-xl p-1 w-full mt-2'>
            <div onClick={()=>setPath(1)} className={path === 1 ? 'rounded-xl md:p-2 xs:py-2 xs:px-1 bg-red-600 text-gray-100 xs:w-full md:w-1/5 text-center cursor-pointer' : 'text-center cursor-pointer md:w-1/5 xs:w-full rounded-xl md:p-2 xs:py-2 xs:px-1  text-gray-500'}>
              <h1>Бүгд</h1>
            </div>
            <div onClick={()=>setPath(2)} className={path === 2 ? 'rounded-xl md:p-2 xs:py-2 xs:px-1 bg-red-600 text-gray-100 xs:w-full md:w-1/5 text-center cursor-pointer' : 'text-center cursor-pointer md:w-1/5 xs:w-full rounded-xl md:p-2 xs:py-2 xs:px-1  text-gray-500'}>
              <h1>Бүртгүүлсэн</h1>
            </div>
            <div onClick={()=>setPath(3)} className={path === 3 ? 'rounded-xl md:p-2 xs:py-2 xs:px-1 bg-red-600 text-gray-100 xs:w-full md:w-1/5 text-center cursor-pointer' : 'text-center cursor-pointer md:w-1/5 xs:w-full rounded-xl md:p-2 xs:py-2 xs:px-1  text-gray-500'}>
              <h1>Ачигдсан</h1>
            </div>
            <div onClick={()=>setPath(4)} className={path === 4 ? 'rounded-xl md:p-2 xs:py-2 xs:px-1 bg-red-600 text-gray-100 xs:w-full md:w-1/5 text-center cursor-pointer' : 'text-center cursor-pointer md:w-1/5 xs:w-full rounded-xl md:p-2 xs:py-2 xs:px-1  text-gray-500'}>
              <h1>Ирсэн</h1>
            </div>
            <div onClick={()=>setPath(5)} className={path === 5 ? 'rounded-xl md:p-2 xs:py-2 xs:px-1 bg-red-600 text-gray-100 xs:w-full md:w-1/5 text-center cursor-pointer' : 'text-center cursor-pointer md:w-1/5 xs:w-full rounded-xl md:p-2 xs:py-2 xs:px-1  text-gray-500'}>
              <h1>Авсан</h1>
            </div>
          </div>

          <div>
            {
              path === 4 &&
              <div>
                <Delivery prods={data.length} callback={callback}/>
                {
                  totalPayment > 0 &&
                  <div>
                    {/* {
                      data.length > 0 &&
                      <div className='flex justify-center'>
                          <div onClick={initiatePayment} className='bg-gray-200 ring-2 ring-gray-300 text-black flex items-center justify-center gap-2 w-full mt-2 cursor-pointer
                              rounded-xl py-2'>
                              <IoCard  size={18}/>
                              <h1>Төлбөр төлөх</h1>
                          </div>
                      </div>
                    } */}
                    <h2 className='font-semibold mt-2 text-end'>Нийт төлбөр: {totalPayment.toLocaleString()} ₮</h2>
                  </div>
                }
              </div>
            }
          </div>

          {
            status ?
            <div>
              <div className='flex justify-center my-2'>
                <img
                className='h-40'
                  src={`data:image/png;base64,${qpay.qr_image}`}
                  alt="QR Code"
                />
              </div>
              <div className='flex justify-center'>
                <button onClick={verifyPayment} className='bg-green-600 p-2 rounded-xl text-white mb-2'>Төлбөр төлөгдсөн эсэхийг шалгах</button>
              </div>
              <div className='grid grid-cols-4 gap-2'>
                {
                  paymentData.map((it, index) => {
                    return (
                      <div
                        onClick={() => handleLink(it.link)}
                        className='p-2 bg-white rounded-xl cursor-pointer' 
                        key={index}
                      >
                        <div className='flex justify-center'>
                        <img className='w-10 h-10 rounded-xl' src={it.logo} />
                        </div>
                        <h1 className='text-center text-sm'>{it.name}</h1>
                      </div>
                    );
                  })
                }
              </div>
            </div>
            :
            <div className='mt-4'>
              {
                load?
                <div>
                  <Skeleton className='h-20 w-full' rounded='xl'/>
                  <Skeleton className='h-20 w-full mt-2' rounded='xl'/>
                  <Skeleton className='h-20 w-full mt-2' rounded='xl'/>
                </div>
                :
                <div>
                  {
                    data.map((it, index) => {
                      return(
                        <ProductCheckCard key={index} data={it} callback={callback}/>
                      )
                    })
                  }
                  {
                    data.length === 0 &&
                    <div className='text-white'>
                      <Empty description={
                        <span className='text-white'>
                          Хоосон байна
                        </span>
                      } />
                      </div>
                  }
                </div>
              }
              <Paginations initialPage={1} total={pagination.totalPage} alldata={pagination.all} onChange={changePage}/> 
            </div>
          }
          <div>
            <TrackAddModal callback={callback}/>
          </div>
      </div>
    )
  }else{
    <Navigate to="/login"/>
  }
}

export default ProductCheck
